// City SEO Data - Données SEO optimisées pour les 26 villes marocaines

export interface CitySEOData {
  slug: string;
  name: string;
  nameFr: string;
  nameEn: string;
  nameAr: string;
  region: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  postalCode: string;
  description: {
    fr: string;
    en: string;
    ar: string;
  };
  metaTitle: {
    fr: string;
    en: string;
    ar: string;
  };
  metaDescription: {
    fr: string;
    en: string;
    ar: string;
  };
  keywords: string[];
  hasAirport: boolean;
  canHostCity: boolean;
  priority: number;
}

export const citiesSEOData: CitySEOData[] = [
  // === VILLES HÔTES CAN 2025 ===
  {
    slug: "casablanca",
    name: "Casablanca",
    nameFr: "Casablanca",
    nameEn: "Casablanca",
    nameAr: "الدار البيضاء",
    region: "Casablanca-Settat",
    coordinates: { latitude: 33.5731, longitude: -7.5898 },
    postalCode: "20000",
    description: {
      fr: "Louez une voiture à Casablanca, capitale économique du Maroc. Visitez la Mosquée Hassan II, la Corniche et le Morocco Mall.",
      en: "Rent a car in Casablanca, Morocco's economic capital. Visit Hassan II Mosque, the Corniche and Morocco Mall.",
      ar: "استأجر سيارة في الدار البيضاء، العاصمة الاقتصادية للمغرب. زر مسجد الحسن الثاني والكورنيش ومغرب مول."
    },
    metaTitle: {
      fr: "Location voiture Casablanca — Comparez les offres | RAKB Maroc",
      en: "Car rental Casablanca — Compare partner offers | RAKB Morocco",
      ar: "تأجير سيارات الدار البيضاء — قارن العروض | RAKB"
    },
    metaDescription: {
      fr: "Location voiture Casablanca sur RAKB : comparez les annonces des agences partenaires, tarifs/jour affichés sur chaque fiche, modalités de caution avant réservation. Réservez en ligne. Prise en charge ville ou aéroport Mohammed V selon les offres.",
      en: "Car rental in Casablanca on RAKB: compare partner listings, per-day rates on each page, deposit rules before you book. Book online. City or Mohammed V airport pickup when offered.",
      ar: "تأجير سيارات في الدار البيضاء عبر RAKB: قارن عروض الوكالات الشريكة، الأسعار اليومية على كل إعلان، شروط التأمين والوديعة قبل الحجز. احجز عبر الإنترنت."
    },
    keywords: ["location voiture casablanca", "louer voiture casablanca", "rent car casablanca", "voiture casablanca aeroport", "location voiture aéroport casablanca"],
    hasAirport: true,
    canHostCity: true,
    priority: 10
  },
  {
    slug: "rabat",
    name: "Rabat",
    nameFr: "Rabat",
    nameEn: "Rabat",
    nameAr: "الرباط",
    region: "Rabat-Salé-Kénitra",
    coordinates: { latitude: 34.0209, longitude: -6.8416 },
    postalCode: "10000",
    description: {
      fr: "Louez une voiture à Rabat, capitale du Maroc. Découvrez la Kasbah des Oudayas, la Tour Hassan et le Mausolée Mohammed V.",
      en: "Rent a car in Rabat, Morocco's capital. Discover the Kasbah of the Udayas, Hassan Tower and Mohammed V Mausoleum.",
      ar: "استأجر سيارة في الرباط، عاصمة المغرب. اكتشف قصبة الأوداية وصومعة حسان."
    },
    metaTitle: {
      fr: "Location voiture Rabat — Comparez les offres | RAKB Maroc",
      en: "Car rental Rabat — Compare partner offers | RAKB Morocco",
      ar: "تأجير سيارات الرباط — قارن العروض | RAKB"
    },
    metaDescription: {
      fr: "Location voiture Rabat sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche, caution et options avant validation. Réservez en ligne. Aéroport Rabat-Salé ou centre-ville selon les offres.",
      en: "Car rental in Rabat on RAKB: compare partner listings, per-day rates on each page, deposit and add-ons before you confirm. Book online. Rabat-Salé airport or city pickup when offered.",
      ar: "تأجير سيارات في الرباط عبر RAKB: قارن الإعلانات، الأسعار اليومية، الوديعة والخيارات قبل التأكيد. احجز عبر الإنترنت."
    },
    keywords: ["location voiture rabat", "louer voiture rabat", "rent car rabat", "location auto rabat aeroport", "location voiture aéroport rabat"],
    hasAirport: true,
    canHostCity: true,
    priority: 10
  },
  {
    slug: "marrakech",
    name: "Marrakech",
    nameFr: "Marrakech",
    nameEn: "Marrakech",
    nameAr: "مراكش",
    region: "Marrakech-Safi",
    coordinates: { latitude: 31.6295, longitude: -7.9811 },
    postalCode: "40000",
    description: {
      fr: "Louez une voiture à Marrakech, la ville rouge. Explorez la place Jemaa el-Fna, les jardins Majorelle et la Médina.",
      en: "Rent a car in Marrakech, the red city. Explore Jemaa el-Fna square, Majorelle Gardens and the Medina.",
      ar: "استأجر سيارة في مراكش، المدينة الحمراء. استكشف ساحة جامع الفنا وحديقة ماجوريل."
    },
    metaTitle: {
      fr: "Location voiture Marrakech — Comparez les offres | RAKB Maroc",
      en: "Car rental Marrakech — Compare partner offers | RAKB Morocco",
      ar: "تأجير سيارات مراكش — قارن العروض | RAKB"
    },
    metaDescription: {
      fr: "Location voiture Marrakech sur RAKB : comparez les agences partenaires, tarifs/jour sur chaque annonce, franchises et kilométrage avant réservation. Aéroport Menara ou centre selon les offres.",
      en: "Car rental in Marrakech on RAKB: compare partner listings, per-day rates, excess and mileage before you book. Menara airport or downtown pickup when offered.",
      ar: "تأجير سيارات في مراكش عبر RAKB: قارن العروض والأسعار اليومية على كل إعلان قبل الحجز."
    },
    keywords: ["location voiture marrakech", "louer voiture marrakech", "rent car marrakech", "voiture marrakech aeroport", "location voiture aéroport marrakech"],
    hasAirport: true,
    canHostCity: true,
    priority: 10
  },
  {
    slug: "fes",
    name: "Fès",
    nameFr: "Fès",
    nameEn: "Fez",
    nameAr: "فاس",
    region: "Fès-Meknès",
    coordinates: { latitude: 34.0181, longitude: -5.0078 },
    postalCode: "30000",
    description: {
      fr: "Louez une voiture à Fès, la capitale spirituelle du Maroc. Visitez la Médina, l'université Al Quaraouiyine et les tanneries.",
      en: "Rent a car in Fez, Morocco's spiritual capital. Visit the Medina, Al Quaraouiyine University and the tanneries.",
      ar: "استأجر سيارة في فاس، العاصمة الروحية للمغرب. زر المدينة القديمة وجامعة القرويين."
    },
    metaTitle: {
      fr: "Location Voiture Fès — Ville & Aéroport Fès-Saïss | RAKB",
      en: "Car Rental Fez — City & Fès-Saïss Airport | RAKB",
      ar: "تأجير سيارات فاس | RAKB"
    },
    metaDescription: {
      fr: "Large choix à Fès. Réservez en ligne, récupérez en ville ou à l'aéroport. Prix clairs, réservation sécurisée.",
      en: "Wide choice in Fez. Book online, pick up in city or at airport. Clear prices, secure booking.",
      ar: "تأجير سيارات في فاس عبر RAKB: قارن العروض، الأسعار على كل إعلان، احجز عبر الإنترنت."
    },
    keywords: ["location voiture fes", "louer voiture fes", "rent car fez", "location auto fes"],
    hasAirport: true,
    canHostCity: true,
    priority: 10
  },
  {
    slug: "tanger",
    name: "Tanger",
    nameFr: "Tanger",
    nameEn: "Tangier",
    nameAr: "طنجة",
    region: "Tanger-Tétouan-Al Hoceïma",
    coordinates: { latitude: 35.7595, longitude: -5.834 },
    postalCode: "90000",
    description: {
      fr: "Louez une voiture à Tanger, porte de l'Afrique. Découvrez le Cap Spartel, la Kasbah et le port de Tanger Med.",
      en: "Rent a car in Tangier, gateway to Africa. Discover Cape Spartel, the Kasbah and Tanger Med port.",
      ar: "استأجر سيارة في طنجة، بوابة أفريقيا. اكتشف رأس سبارتيل والقصبة."
    },
    metaTitle: {
      fr: "Location voiture Tanger — Comparez les offres | RAKB Maroc",
      en: "Car rental Tangier — Compare partner offers | RAKB Morocco",
      ar: "تأجير سيارات طنجة — قارن العروض | RAKB"
    },
    metaDescription: {
      fr: "Location voiture Tanger sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche, modalités avant réservation. Aéroport Ibn Battouta, port Tanger Med ou centre selon les offres.",
      en: "Car rental in Tangier on RAKB: compare partner listings, per-day rates on each page before you book. Ibn Battouta airport, Tanger Med port, or city pickup when offered.",
      ar: "تأجير سيارات في طنجة عبر RAKB: قارن الإعلانات والأسعار اليومية قبل الحجز."
    },
    keywords: ["location voiture tanger", "louer voiture tanger", "rent car tangier", "voiture tanger aeroport", "location voiture aéroport tanger"],
    hasAirport: true,
    canHostCity: true,
    priority: 10
  },
  // === AUTRES VILLES ===
  {
    slug: "agadir",
    name: "Agadir",
    nameFr: "Agadir",
    nameEn: "Agadir",
    nameAr: "أكادير",
    region: "Souss-Massa",
    coordinates: { latitude: 30.4278, longitude: -9.5981 },
    postalCode: "80000",
    description: {
      fr: "Louez une voiture à Agadir. Profitez des plages, du port et de la Kasbah Oufella.",
      en: "Rent a car in Agadir. Enjoy the beaches, port and Kasbah Oufella.",
      ar: "استأجر سيارة في أكادير. استمتع بالشواطئ والميناء."
    },
    metaTitle: { fr: "Location Voiture Agadir | RAKB", en: "Car Rental Agadir | RAKB", ar: "تأجير سيارات أكادير | RAKB" },
    metaDescription: { fr: "Location voiture à Agadir sur RAKB : comparez les agences partenaires, tarifs/jour sur chaque annonce. Réservez en ligne.", en: "Car rental in Agadir on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في أكادير عبر RAKB: قارن العروض والأسعار على كل إعلان. احجز عبر الإنترنت." },
    keywords: ["location voiture agadir", "louer voiture agadir", "rent car agadir", "location voiture aéroport agadir"],
    hasAirport: true,
    canHostCity: false,
    priority: 9
  },
  {
    slug: "meknes",
    name: "Meknès",
    nameFr: "Meknès",
    nameEn: "Meknes",
    nameAr: "مكناس",
    region: "Fès-Meknès",
    coordinates: { latitude: 33.8935, longitude: -5.5473 },
    postalCode: "50000",
    description: { fr: "Louez une voiture à Meknès, cité impériale.", en: "Rent a car in Meknes, imperial city.", ar: "استأجر سيارة في مكناس." },
    metaTitle: { fr: "Location Voiture Meknès | RAKB", en: "Car Rental Meknes | RAKB", ar: "تأجير سيارات مكناس | RAKB" },
    metaDescription: { fr: "Location de voiture à Meknès sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Meknes on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في مكناس." },
    keywords: ["location voiture meknes"],
    hasAirport: false,
    canHostCity: false,
    priority: 8
  },
  {
    slug: "oujda",
    name: "Oujda",
    nameFr: "Oujda",
    nameEn: "Oujda",
    nameAr: "وجدة",
    region: "Oriental",
    coordinates: { latitude: 34.6867, longitude: -1.9114 },
    postalCode: "60000",
    description: { fr: "Louez une voiture à Oujda.", en: "Rent a car in Oujda.", ar: "استأجر سيارة في وجدة." },
    metaTitle: { fr: "Location Voiture Oujda | RAKB", en: "Car Rental Oujda | RAKB", ar: "تأجير سيارات وجدة | RAKB" },
    metaDescription: { fr: "Location de voiture à Oujda sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Oujda on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في وجدة." },
    keywords: ["location voiture oujda"],
    hasAirport: true,
    canHostCity: false,
    priority: 7
  },
  {
    slug: "kenitra",
    name: "Kénitra",
    nameFr: "Kénitra",
    nameEn: "Kenitra",
    nameAr: "القنيطرة",
    region: "Rabat-Salé-Kénitra",
    coordinates: { latitude: 34.261, longitude: -6.5802 },
    postalCode: "14000",
    description: { fr: "Louez une voiture à Kénitra.", en: "Rent a car in Kenitra.", ar: "استأجر سيارة في القنيطرة." },
    metaTitle: { fr: "Location Voiture Kénitra | RAKB", en: "Car Rental Kenitra | RAKB", ar: "تأجير سيارات القنيطرة | RAKB" },
    metaDescription: { fr: "Location de voiture à Kénitra sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Kenitra on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في القنيطرة." },
    keywords: ["location voiture kenitra"],
    hasAirport: false,
    canHostCity: false,
    priority: 7
  },
  {
    slug: "tetouan",
    name: "Tétouan",
    nameFr: "Tétouan",
    nameEn: "Tetouan",
    nameAr: "تطوان",
    region: "Tanger-Tétouan-Al Hoceïma",
    coordinates: { latitude: 35.5785, longitude: -5.3684 },
    postalCode: "93000",
    description: { fr: "Louez une voiture à Tétouan.", en: "Rent a car in Tetouan.", ar: "استأجر سيارة في تطوان." },
    metaTitle: { fr: "Location Voiture Tétouan | RAKB", en: "Car Rental Tetouan | RAKB", ar: "تأجير سيارات تطوان | RAKB" },
    metaDescription: { fr: "Location de voiture à Tétouan sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Tetouan on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في تطوان." },
    keywords: ["location voiture tetouan"],
    hasAirport: false,
    canHostCity: false,
    priority: 7
  },
  {
    slug: "essaouira",
    name: "Essaouira",
    nameFr: "Essaouira",
    nameEn: "Essaouira",
    nameAr: "الصويرة",
    region: "Marrakech-Safi",
    coordinates: { latitude: 31.5085, longitude: -9.7595 },
    postalCode: "44000",
    description: { fr: "Louez une voiture à Essaouira, cité des alizés.", en: "Rent a car in Essaouira, city of trade winds.", ar: "استأجر سيارة في الصويرة." },
    metaTitle: { fr: "Location Voiture Essaouira | RAKB", en: "Car Rental Essaouira | RAKB", ar: "تأجير سيارات الصويرة | RAKB" },
    metaDescription: { fr: "Location de voiture à Essaouira sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Essaouira on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في الصويرة." },
    keywords: ["location voiture essaouira"],
    hasAirport: true,
    canHostCity: false,
    priority: 6
  },
  {
    slug: "ouarzazate",
    name: "Ouarzazate",
    nameFr: "Ouarzazate",
    nameEn: "Ouarzazate",
    nameAr: "ورزازات",
    region: "Drâa-Tafilalet",
    coordinates: { latitude: 30.9189, longitude: -6.8936 },
    postalCode: "45000",
    description: { fr: "Louez une voiture à Ouarzazate, porte du désert.", en: "Rent a car in Ouarzazate, gateway to the desert.", ar: "استأجر سيارة في ورزازات." },
    metaTitle: { fr: "Location Voiture Ouarzazate | RAKB", en: "Car Rental Ouarzazate | RAKB", ar: "تأجير سيارات ورزازات | RAKB" },
    metaDescription: { fr: "Location de voiture à Ouarzazate sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Ouarzazate on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في ورزازات." },
    keywords: ["location voiture ouarzazate"],
    hasAirport: true,
    canHostCity: false,
    priority: 6
  },
  {
    slug: "el-jadida",
    name: "El Jadida",
    nameFr: "El Jadida",
    nameEn: "El Jadida",
    nameAr: "الجديدة",
    region: "Casablanca-Settat",
    coordinates: { latitude: 33.2316, longitude: -8.5007 },
    postalCode: "24000",
    description: { fr: "Louez une voiture à El Jadida.", en: "Rent a car in El Jadida.", ar: "استأجر سيارة في الجديدة." },
    metaTitle: { fr: "Location Voiture El Jadida | RAKB", en: "Car Rental El Jadida | RAKB", ar: "تأجير سيارات الجديدة | RAKB" },
    metaDescription: { fr: "Location de voiture à El Jadida sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in El Jadida on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في الجديدة." },
    keywords: ["location voiture el jadida"],
    hasAirport: false,
    canHostCity: false,
    priority: 6
  },
  {
    slug: "mohammedia",
    name: "Mohammedia",
    nameFr: "Mohammedia",
    nameEn: "Mohammedia",
    nameAr: "المحمدية",
    region: "Casablanca-Settat",
    coordinates: { latitude: 33.6866, longitude: -7.3827 },
    postalCode: "28800",
    description: { fr: "Louez une voiture à Mohammedia.", en: "Rent a car in Mohammedia.", ar: "استأجر سيارة في المحمدية." },
    metaTitle: { fr: "Location Voiture Mohammedia | RAKB", en: "Car Rental Mohammedia | RAKB", ar: "تأجير سيارات المحمدية | RAKB" },
    metaDescription: { fr: "Location de voiture à Mohammedia sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Mohammedia on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في المحمدية." },
    keywords: ["location voiture mohammedia"],
    hasAirport: false,
    canHostCity: false,
    priority: 6
  },
  {
    slug: "safi",
    name: "Safi",
    nameFr: "Safi",
    nameEn: "Safi",
    nameAr: "آسفي",
    region: "Marrakech-Safi",
    coordinates: { latitude: 32.2994, longitude: -9.2372 },
    postalCode: "46000",
    description: { fr: "Louez une voiture à Safi.", en: "Rent a car in Safi.", ar: "استأجر سيارة في آسفي." },
    metaTitle: { fr: "Location Voiture Safi | RAKB", en: "Car Rental Safi | RAKB", ar: "تأجير سيارات آسفي | RAKB" },
    metaDescription: { fr: "Location de voiture à Safi sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Safi on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في آسفي." },
    keywords: ["location voiture safi"],
    hasAirport: false,
    canHostCity: false,
    priority: 6
  },
  {
    slug: "beni-mellal",
    name: "Béni Mellal",
    nameFr: "Béni Mellal",
    nameEn: "Beni Mellal",
    nameAr: "بني ملال",
    region: "Béni Mellal-Khénifra",
    coordinates: { latitude: 32.3373, longitude: -6.3498 },
    postalCode: "23000",
    description: { fr: "Louez une voiture à Béni Mellal.", en: "Rent a car in Beni Mellal.", ar: "استأجر سيارة في بني ملال." },
    metaTitle: { fr: "Location Voiture Béni Mellal | RAKB", en: "Car Rental Beni Mellal | RAKB", ar: "تأجير سيارات بني ملال | RAKB" },
    metaDescription: { fr: "Location de voiture à Béni Mellal sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Beni Mellal on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في بني ملال." },
    keywords: ["location voiture beni mellal"],
    hasAirport: false,
    canHostCity: false,
    priority: 5
  },
  {
    slug: "nador",
    name: "Nador",
    nameFr: "Nador",
    nameEn: "Nador",
    nameAr: "الناظور",
    region: "Oriental",
    coordinates: { latitude: 35.1681, longitude: -2.9287 },
    postalCode: "62000",
    description: { fr: "Louez une voiture à Nador.", en: "Rent a car in Nador.", ar: "استأجر سيارة في الناظور." },
    metaTitle: { fr: "Location Voiture Nador | RAKB", en: "Car Rental Nador | RAKB", ar: "تأجير سيارات الناظور | RAKB" },
    metaDescription: { fr: "Location de voiture à Nador sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Nador on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في الناظور." },
    keywords: ["location voiture nador"],
    hasAirport: true,
    canHostCity: false,
    priority: 5
  },
  {
    slug: "chefchaouen",
    name: "Chefchaouen",
    nameFr: "Chefchaouen",
    nameEn: "Chefchaouen",
    nameAr: "شفشاون",
    region: "Tanger-Tétouan-Al Hoceïma",
    coordinates: { latitude: 35.171, longitude: -5.2636 },
    postalCode: "91000",
    description: { fr: "Louez une voiture à Chefchaouen, la perle bleue.", en: "Rent a car in Chefchaouen, the blue pearl.", ar: "استأجر سيارة في شفشاون." },
    metaTitle: { fr: "Location Voiture Chefchaouen | RAKB", en: "Car Rental Chefchaouen | RAKB", ar: "تأجير سيارات شفشاون | RAKB" },
    metaDescription: { fr: "Location de voiture à Chefchaouen sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Chefchaouen on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في شفشاون." },
    keywords: ["location voiture chefchaouen"],
    hasAirport: false,
    canHostCity: false,
    priority: 5
  },
  {
    slug: "taza",
    name: "Taza",
    nameFr: "Taza",
    nameEn: "Taza",
    nameAr: "تازة",
    region: "Fès-Meknès",
    coordinates: { latitude: 34.21, longitude: -4.01 },
    postalCode: "35000",
    description: { fr: "Louez une voiture à Taza.", en: "Rent a car in Taza.", ar: "استأجر سيارة في تازة." },
    metaTitle: { fr: "Location Voiture Taza | RAKB", en: "Car Rental Taza | RAKB", ar: "تأجير سيارات تازة | RAKB" },
    metaDescription: { fr: "Location de voiture à Taza sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Taza on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في تازة." },
    keywords: ["location voiture taza"],
    hasAirport: false,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "khemisset",
    name: "Khémisset",
    nameFr: "Khémisset",
    nameEn: "Khemisset",
    nameAr: "الخميسات",
    region: "Rabat-Salé-Kénitra",
    coordinates: { latitude: 33.8242, longitude: -6.0664 },
    postalCode: "15000",
    description: { fr: "Louez une voiture à Khémisset.", en: "Rent a car in Khemisset.", ar: "استأجر سيارة في الخميسات." },
    metaTitle: { fr: "Location Voiture Khémisset | RAKB", en: "Car Rental Khemisset | RAKB", ar: "تأجير سيارات الخميسات | RAKB" },
    metaDescription: { fr: "Location de voiture à Khémisset sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Khemisset on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في الخميسات." },
    keywords: ["location voiture khemisset"],
    hasAirport: false,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "larache",
    name: "Larache",
    nameFr: "Larache",
    nameEn: "Larache",
    nameAr: "العرائش",
    region: "Tanger-Tétouan-Al Hoceïma",
    coordinates: { latitude: 35.1932, longitude: -6.1561 },
    postalCode: "92000",
    description: { fr: "Louez une voiture à Larache.", en: "Rent a car in Larache.", ar: "استأجر سيارة في العرائش." },
    metaTitle: { fr: "Location Voiture Larache | RAKB", en: "Car Rental Larache | RAKB", ar: "تأجير سيارات العرائش | RAKB" },
    metaDescription: { fr: "Location de voiture à Larache sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Larache on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في العرائش." },
    keywords: ["location voiture larache"],
    hasAirport: false,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "khouribga",
    name: "Khouribga",
    nameFr: "Khouribga",
    nameEn: "Khouribga",
    nameAr: "خريبكة",
    region: "Béni Mellal-Khénifra",
    coordinates: { latitude: 32.8811, longitude: -6.9063 },
    postalCode: "25000",
    description: { fr: "Louez une voiture à Khouribga.", en: "Rent a car in Khouribga.", ar: "استأجر سيارة في خريبكة." },
    metaTitle: { fr: "Location Voiture Khouribga | RAKB", en: "Car Rental Khouribga | RAKB", ar: "تأجير سيارات خريبكة | RAKB" },
    metaDescription: { fr: "Location de voiture à Khouribga sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Khouribga on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في خريبكة." },
    keywords: ["location voiture khouribga"],
    hasAirport: false,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "settat",
    name: "Settat",
    nameFr: "Settat",
    nameEn: "Settat",
    nameAr: "سطات",
    region: "Casablanca-Settat",
    coordinates: { latitude: 33.0017, longitude: -7.6166 },
    postalCode: "26000",
    description: { fr: "Louez une voiture à Settat.", en: "Rent a car in Settat.", ar: "استأجر سيارة في سطات." },
    metaTitle: { fr: "Location Voiture Settat | RAKB", en: "Car Rental Settat | RAKB", ar: "تأجير سيارات سطات | RAKB" },
    metaDescription: { fr: "Location de voiture à Settat sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Settat on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في سطات." },
    keywords: ["location voiture settat"],
    hasAirport: false,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "ifrane",
    name: "Ifrane",
    nameFr: "Ifrane",
    nameEn: "Ifrane",
    nameAr: "إفران",
    region: "Fès-Meknès",
    coordinates: { latitude: 33.5228, longitude: -5.1107 },
    postalCode: "53000",
    description: { fr: "Louez une voiture à Ifrane, la petite Suisse.", en: "Rent a car in Ifrane, the little Switzerland.", ar: "استأجر سيارة في إفران." },
    metaTitle: { fr: "Location Voiture Ifrane | RAKB", en: "Car Rental Ifrane | RAKB", ar: "تأجير سيارات إفران | RAKB" },
    metaDescription: { fr: "Location de voiture à Ifrane sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Ifrane on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في إفران." },
    keywords: ["location voiture ifrane"],
    hasAirport: false,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "errachidia",
    name: "Errachidia",
    nameFr: "Errachidia",
    nameEn: "Errachidia",
    nameAr: "الراشيدية",
    region: "Drâa-Tafilalet",
    coordinates: { latitude: 31.9314, longitude: -4.4267 },
    postalCode: "52000",
    description: { fr: "Louez une voiture à Errachidia.", en: "Rent a car in Errachidia.", ar: "استأجر سيارة في الراشيدية." },
    metaTitle: { fr: "Location Voiture Errachidia | RAKB", en: "Car Rental Errachidia | RAKB", ar: "تأجير سيارات الراشيدية | RAKB" },
    metaDescription: { fr: "Location de voiture à Errachidia sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Errachidia on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في الراشيدية." },
    keywords: ["location voiture errachidia"],
    hasAirport: true,
    canHostCity: false,
    priority: 4
  },
  {
    slug: "dakhla",
    name: "Dakhla",
    nameFr: "Dakhla",
    nameEn: "Dakhla",
    nameAr: "الداخلة",
    region: "Dakhla-Oued Ed-Dahab",
    coordinates: { latitude: 23.6848, longitude: -15.957 },
    postalCode: "73000",
    description: { fr: "Louez une voiture à Dakhla.", en: "Rent a car in Dakhla.", ar: "استأجر سيارة في الداخلة." },
    metaTitle: { fr: "Location Voiture Dakhla | RAKB", en: "Car Rental Dakhla | RAKB", ar: "تأجير سيارات الداخلة | RAKB" },
    metaDescription: { fr: "Location de voiture à Dakhla sur RAKB : comparez les annonces partenaires, tarifs/jour sur chaque fiche. Réservez en ligne.", en: "Car rental in Dakhla on RAKB: compare partner listings, per-day rates on each listing. Book online.", ar: "تأجير سيارات في الداخلة." },
    keywords: ["location voiture dakhla"],
    hasAirport: true,
    canHostCity: false,
    priority: 3
  }
];

// === HELPER FUNCTIONS ===

export const getCityBySlug = (slug: string): CitySEOData | undefined =>
  citiesSEOData.find(city => city.slug === slug.toLowerCase());

export type CityDisplayLocale = "fr" | "en" | "ar";

/** Nom affiché de la ville selon la langue UI (pages /location-voiture/:city). */
export const getCityLocalizedName = (
  city: CitySEOData,
  locale: CityDisplayLocale
): string => {
  if (locale === "ar") return city.nameAr || city.name;
  if (locale === "en") return city.nameEn || city.name;
  return city.nameFr || city.name;
};

export const getCanHostCities = (): CitySEOData[] =>
  citiesSEOData.filter(city => city.canHostCity);

export const getAllCitySlugs = (): string[] =>
  citiesSEOData.map(city => city.slug);

export const getCitiesByPriority = (minPriority = 0): CitySEOData[] =>
  citiesSEOData.filter(city => city.priority >= minPriority).sort((a, b) => b.priority - a.priority);

/** Résout le slug ville canonique depuis le libellé affiché sur une annonce. */
export const getCitySlugByListingName = (listingCity?: string | null): string | undefined => {
  if (!listingCity?.trim()) return undefined;
  const norm = listingCity.trim().toLowerCase();
  return citiesSEOData.find(
    (c) =>
      c.slug === norm ||
      c.name.toLowerCase() === norm ||
      c.nameFr.toLowerCase() === norm ||
      c.nameEn.toLowerCase() === norm
  )?.slug;
};
